module.exports = __webpack_public_path__ + "static/img/202217.c35e104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202217.jpg
// module id = 3Byp
// module chunks = 0